export default {
    hazard: {
        name: "Hazard",
        url: "nwcg_safety/hazard",
    },
    safety_zone: {
        name: "Safety Zone",
        url: "nwcg_safety/safety_zone",
    },
}
